import { render, staticRenderFns } from "./rangeControl.vue?vue&type=template&id=545d1074&scoped=true&"
import script from "./rangeControl.vue?vue&type=script&lang=js&"
export * from "./rangeControl.vue?vue&type=script&lang=js&"
import style0 from "./rangeControl.vue?vue&type=style&index=0&id=545d1074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d1074",
  null
  
)

export default component.exports